import {RangeModel} from '../shared/range.model';
import {Enums} from '../../extensions/enums';
import {QuestionExtendedModel} from '../question-extended.model';

export class SizeComparisonNumbersModel extends QuestionExtendedModel {

  minorVersion = 1;
  majorVersion = 8;
  revisionVersion = 3;

  model = {
    firstRange: new RangeModel(),
    symbol: Enums.SizeComparisonTypes.greater,
    possibleAnswers: new RangeModel(),
    leftSideUnknown: true,
    numAnswers: 4,
    imageTypeOne: null
  };

  static generateModel(json: any): SizeComparisonNumbersModel {

    const q = new SizeComparisonNumbersModel();

    const model = json.model;

    if (model) {

      if (model.firstRange) {
        q.model.firstRange = RangeModel.generateModel(model.firstRange);
      }

      if (model.possibleAnswers) {
        q.model.possibleAnswers = RangeModel.generateModel(model.possibleAnswers);
      }

      q.model.numAnswers = model.numAnswers;
      q.model.imageTypeOne = model.imageTypeOne;

    }

    return q;

  }


}
